import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Expired/revoked sessions: tell the AuthProvider so the app returns to the login screen instead of showing a wall of errors.
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && !String(e.config?.url || "").startsWith("/auth/")) window.dispatchEvent(new CustomEvent("tqi:unauthorized", { detail: e.response?.data?.detail }));
    return Promise.reject(e);
  },
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York", dateStyle: "medium", timeStyle: "short" }) + " ET" : "—";
export const fmtDate = (d) => (d ? d : "—");
export const fmtMoney = (s) => (s == null || s === "" ? "—" : Number(s).toLocaleString("en-US", { style: "currency", currency: "USD" }));
export const fmtNum = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US"));
export const fmtNaive = (s) => (s ? s.replace("T", " ").slice(0, 16) : "—");
